export default __webpack_public_path__ + "static/media/demon1.05990301.png";